import React, { useLayoutEffect, useState } from 'react';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import {connect} from 'react-redux';
import styles from "./styles.scss";
import toastMessageActions from 'jd-library/toastMessageActions';
import { scrollIntoView } from '../../../../../utills';
import FormLabel from 'jd-library/FormLabel';

import { updateSpecificationData } from '../../../../../actions/productSpecification';

function CustomAttributesGenerator(props){

    const {
        initCustomSpecAttributes,
        savedCustomSpecAttributes
    } = props;

    const [cusAttributes, setCusAttributes] = useState([]);
    const [maxHeight, setMaxHeight] = useState(initCustomSpecAttributes.length?initCustomSpecAttributes.length*50 + 35:50);
    const alternate = {
        key: "value",
        value : "key"
    }

    useLayoutEffect(() => {
        setCusAttributes(initCustomSpecAttributes); 
        setMaxHeight(initCustomSpecAttributes.length == 1?50:(initCustomSpecAttributes.length*60) - 5)
    }, [initCustomSpecAttributes])

    useLayoutEffect(() => {
        let attributes = [];
        let finalObj = [];
        if(savedCustomSpecAttributes.length){
            attributes = savedCustomSpecAttributes.filter(item => !(['ins_days', 'ins_amount', 'ins_cover' ,'ins_not_cover'].includes(item.key.value)));
        }else{
            attributes = [...initCustomSpecAttributes];
        }
        attributes.map((element)=> {
            if (Object.keys(element.key).length!=0 && Object.keys(element.value).length!=0){
                finalObj.push(element)
            }
        })
        setCusAttributes(finalObj);
        onChange(finalObj)
    }, [savedCustomSpecAttributes]);



    function onChange(data) {
        props.updateSpecificationData({initCustomSpecAttributes: data})
    }

    function addCustomAttributeField(e) {
        const attritbuteList = [...cusAttributes];
        attritbuteList.push({
            key: {},
            value: {}
        });
        if(!cusAttributes.length) {
            attritbuteList.push({
                key: {},
                value: {}
            });
        }
        setMaxHeight(attritbuteList.length <= 1 ? 50 :  maxHeight+60);
        onChange(attritbuteList);
    }

    function handleCustomAttributeOnChange(e, index){
        let { 
            value,
            name,
        } = e.target;

        let attributeList = [...cusAttributes];
        value = value.replace(/[^\w \xC0-\xFF]/g,'')
        if(!attributeList.length) {
            attributeList = [{
                key: {
                    value: name == 'key' ? value : '',
                    error: ''
                },
                value: {
                    value: name == 'value' ? value : '',
                    error: ''
                }
            }]
        }else {
            attributeList[index][name] = {
                value,
                error: ""
            }
            attributeList[index][alternate[name]] = {
                ...attributeList[index][alternate[name]],
                error: ""
            }
        }
        onChange(attributeList);

    }

    function removeCustomAttributes(index){
        const attributeList = [...cusAttributes];
        attributeList.splice(index,1);
        setMaxHeight(attributeList.length <= 1  ? 50 : maxHeight-60);
        onChange(attributeList);
    }

    return (
        <div className={styles['custom-attribute']}>
            <div className={styles['custom-attirbute-header']}>
                <FormLabel className={styles['left-header']}>
                    Specification Name
                </FormLabel>
                <FormLabel className={styles['right-header']}>
                    Specification Value
                </FormLabel>
            </div>
            <div
                className={styles["custom-attribute-input-container"]}
                // style={{
                //     height: `${maxHeight}px`
                // }}
                >
                {
                    cusAttributes.length > 1 && cusAttributes.map((item,index) => {
                        return (
                            <div key={"_"+ index} className={styles["attribute-input-wrapper"]}>
                                <div className={styles["left-content"]}>
                                    <InputWithMovingLabel
                                        errorMessage={item.key?.error || ""}
                                        label=""
                                        input={{
                                            value: item.key?.value || "" ,
                                            name: "key",
                                            onChange: (e) => handleCustomAttributeOnChange(e, index),
                                            autoComplete: "off",
                                            className: item.key?.error ? styles['inputError'] : "",
                                            placeHolder: index == 0 ? "Color" : "",
                                            onFocus: e => props.isMobile && scrollIntoView(e.currentTarget, "prod-spec-slider-container")
                                        }}
                                    />
                                </div>
                                <div className={styles["right-content"]}>
                                    <InputWithMovingLabel
                                        errorMessage={item.value?.error || ""}
                                        label=""
                                        input={{
                                            value: item.value?.value || "",
                                            name: "value",
                                            onChange: (e) => handleCustomAttributeOnChange(e, index),
                                            autoComplete: "off",
                                            className: item.value?.error ? styles['inputError']: "",
                                            placeHolder: index == 0 ? "Red" : "",
                                            onFocus: e => props.isMobile && scrollIntoView(e.currentTarget, "prod-spec-slider-container")
                                        }}
                                    />
                                </div>
                                {
                                    <span className={`icon-trash ${styles["delete-icon"]} ${styles["font16"]} ${cusAttributes.length == 1 ? styles['disabled']:''} ${styles["cursor-pointer"]}`} onClick={() => removeCustomAttributes(index)} ></span>
                                }
                            </div>
                        )
                    }) || (
                        <div className={styles["attribute-input-wrapper"]}>
                                <div className={styles["left-content"]}>
                                    <InputWithMovingLabel
                                        errorMessage={""}
                                        label=""
                                        input={{
                                            value:  cusAttributes[0]?.key?.value || '',
                                            name: "key",
                                            placeHolder:"Color",
                                            onChange: (e) => handleCustomAttributeOnChange(e, 0)
                                        }}
                                    />
                                </div>
                                <div className={styles["right-content"]}>
                                    <InputWithMovingLabel
                                        errorMessage={cusAttributes[0]?.value?.error || ""}
                                        label=""
                                        input={{
                                            value: cusAttributes[0]?.value?.value || '',
                                            name: "value",
                                            placeHolder:"Red",
                                            className: cusAttributes[0]?.value?.error ? styles['inputError']: "",
                                            onChange: (e) => handleCustomAttributeOnChange(e, 0)
                                        }}
                                    />
                                </div>
                                <span style={{cursor: "default", opacity: "0.5",pointerEvents:"none"}} className={`icon-trash ${styles["delete-icon"]} ${styles["font16"]} ${styles["cursor-pointer"]}`}></span>
                        </div>
                    )
                }
            </div>
            {

                <div className={styles["custom-attribute-add-btn"]}>
                    <span className={styles["btn-wrapper"]} onClick={addCustomAttributeField}>
                        <span className={`icon-plus ${styles['bttn-icon']} ${styles["primary"]}`}></span>
                        <span className={`${styles["attribute-add-btn-text"]} ${styles["primary"]}`}>Add Another Specification</span>
                    </span>
                </div>
            }
        </div>
    )
}

const mapStateToProps = (state, props) => {
    return {
        ...props,
        initCustomSpecAttributes: state.productSpecification.initCustomSpecAttributes,
        savedCustomSpecAttributes: state.productSpecification.savedCustomSpecAttributes,
        isEnrichSpec: state.productSpecification?.isEnrichSpec,
        isMobile: state.library.deviceData.isMobile
    }
};

const mapDispatchToProps = (dispatch) => ({
    updateSpecificationData: (payload) => dispatch(updateSpecificationData(payload)),
    showToastMessage: (payload) => dispatch(toastMessageActions.showMessage(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomAttributesGenerator);